export function getMMMRuns() {
  const url = '/data_model_run/mmm/metadata';
  return fetch(url, {
    credentials: 'include',
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(({ data }) => data);
}

export function getMMMData(id) {
  const url = `/data_model_run/mmm/${id}`;
  return fetch(url, {
    credentials: 'include',
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(({ data }) => data);
}

export const getMMMCustomFeedsData = () => {
  const url = '/data-reporting/mmm-custom-feeds';
  return fetch(url, {
    credentials: 'include',
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(response => response.response);
};

export const getMMMCustomFeedsDimensions = () => {
  const url = '/data-reporting/mmm-custom-feeds?dimensions=true';
  return fetch(url, {
    credentials: 'include',
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(response => response.response);
};

export function getMMMCustomChannels() {
  const url = '/mmm/channel';
  return fetch(url, {
    credentials: 'include',
  })
    .then(response => response.json())
    .then(data => data.response);
}

export function postMMMCustomChannel(obj) {
  const url = '/mmm/channel';
  return fetch(url, {
    credentials: 'include',
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(obj),
  })
    .then(response => response.json())
    .then(data => data.response);
}

export function getMMMCustomSubchannels() {
  const url = '/mmm/subchannel';
  return fetch(url, {
    credentials: 'include',
  })
    .then(response => response.json())
    .then(data => data.response);
}

export function postMMMCustomSubchannel(obj) {
  const url = '/mmm/subchannel';
  return fetch(url, {
    credentials: 'include',
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(obj),
  })
    .then(response => response.json())
    .then(data => data.response);
}

export function putMMMCustomConfiguration(obj) {
  const url = '/mmm/configuration';
  return fetch(url, {
    credentials: 'include',
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(obj),
  })
    .then(response => response.json())
    .then(data => data.response);
}

export function getMMMLockStatus() {
  const url = '/mmm/lock';
  return fetch(url, {
    credentials: 'include',
  })
    .then(response => response.json())
    .then(data => data.response);
}

export function postMMMLockStatus(obj) {
  const url = '/mmm/lock';
  return fetch(url, {
    credentials: 'include',
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(obj),
  })
    .then(response => response.json())
    .then(data => data.response);
}
